import React, { useState } from 'react';
import { Blade, Button, ProgressIndicator, Select } from 'rhombus-react';
import { useDispatch, useSelector } from 'react-redux';

import useActiveCreative from 'hooks/useActiveCreative';

import { bulkStatusChange } from 'reducers/Creatives';
import { closeModal } from 'reducers/Modal';

import { labelWithCount, noop } from 'utils/common';
import { shouldDisplayAction } from 'utils/CreativeActions';

import CreativesTable from 'widgets/table/CreativesTable';

import './RecallCreatives.css';

const recallOptions = [
	{ value: "We need to change the creative", label: "We need to change the creative", key: "change" },
	{ value: "We need to rename the creative", label: "We need to rename the creative", key: "rename" },
	{ value: "The creative is no longer required", label: "The creative is no longer required", key: "notRequired" },
	{ value: "The campaign is to be pulled", label: "The campaign is to be pulled", key: "pulled" },
];

export default function RecallCreatives(props){
	const { creatives = [], libraryId } = props
		, pluralize = creatives.length > 1 ? 's' : ''
		, dispatch = useDispatch()
		, user = useSelector(state => state.you)
		, recallableCreatives = creatives.filter(creative => shouldDisplayAction.recall(user, creative))
		, [isSubmitting, setIsSubmitting] = useState(false)
		, [recallReason, setRecallReason] = useState('');

	let modalTitle
		, selectLabel;

	if(creatives.length === 0) {return null;}

	useActiveCreative(creatives[0].id);

	if(creatives.length > 1){
		modalTitle = `Recall Creative - ${creatives.length} Creatives`;
		selectLabel = `Reason for Recalling the Selected Creatives`;
	} else {
		modalTitle = `Recall Creative - ${creatives[0].name}`;
		selectLabel = `Reason for Recalling the Selected Creative`;
	}

	const renderContent = () => {
		return (
			<div className="recall-creatives-content">
				<ProgressIndicator isLoading={isSubmitting} />
				<div className="select-container">
					<Select
						name="recall-reason"
						label={selectLabel}
						options={recallOptions}
						onChange={selectedOption => setRecallReason(selectedOption?.value || '')}
						value={recallReason}
						autoFocus={true}
						onMenuScrollToBottom={noop}
					/>
				</div>
				<CreativesTable className="recall-creatives-table" shouldLinkPreview={false} creatives={recallableCreatives} />
			</div>
		);
	};

	const handleSubmit = () => {
		setIsSubmitting(true);
		return dispatch(bulkStatusChange({
			status: 'recall',
			libraryId,
			creativeIds: creatives.map(creative => creative.id),
			reason: recallReason,
		})).then((resp) => {
			setIsSubmitting(false);
			if(resp?.success) {return onClose();}
		});
	};

	const renderFooter = () => {
		return (
			<>
				<Button key="cancel" theme="grey" disabled={isSubmitting} onClick={onClose}>Cancel</Button>
				<Button key="recall" theme="green" disabled={!recallReason || isSubmitting} onClick={handleSubmit}>{labelWithCount(`Recall Creative${pluralize}`, creatives.length)}</Button>
			</>
		);
	};

	const onClose = () => dispatch(closeModal());

	return (
		<Blade
			type="modal"
			setAppTitle={false}
			className="recall-creatives"
			title={modalTitle}
			allowFullScreen={false}
			xclose
			onClose={onClose}
			bladeProps={{ verticallyCenter:true }}
			renderContent={renderContent}
			renderFooter={renderFooter}
		/>
	);
}
